import { createBlock } from "@wordpress/blocks";
import type { Title, TitleSelection, TitleIdType, TitleObjectType } from "@/types";
import { generateShortcode } from "./save";

const SHORTCODE_NAME = "justwatch";

/**
 * Converts shortcode attributes into block attributes.
 */
const shortcodeToBlockAttributes = (attrs: Record<string, string>): TitleSelection => {
  const attrObjectType = attrs["object-type"];
  const objectType = (attrObjectType && ['movie', 'show'].includes(attrObjectType))
    ? attrObjectType as TitleObjectType
    : "movie" as TitleObjectType;

  const seasonNumber = attrs["season-number"] || attrs["season"];
  const episodeNumber = attrs["episode-number"] || attrs["episode"];
  const idType = (attrs["id-type"] && ['imdb', 'tmdb'].includes(attrs["id-type"]))
    ? attrs["id-type"] as TitleIdType
    : "justwatch" as TitleIdType;
  const id = attrs.id || "";

  return {
    id,
    idType,
    objectType,
    seasonNumber: seasonNumber ? parseInt(seasonNumber, 10) : 1,
    episodeNumber: episodeNumber ? parseInt(episodeNumber, 10) : 1,
    meta: {
      justwatchId: parseInt(id, 10),
      objectType,
    } as Title,
  };
}

/**
 * Transforms for converting between the JustWatch block and shortcode.
 */
export default {
  from: [
    {
      type: "shortcode",
      tag: SHORTCODE_NAME,
      transform: ({ named }: { named: Record<string, string> }): Partial<Record<string, any>> => {
        const blockAttrs = shortcodeToBlockAttributes(named);

        return createBlock("justwatch/partners", blockAttrs);
      }
    },
  ],
  to: [
    {
      type: "shortcode",
      transform: (attributes: TitleSelection): string => generateShortcode(attributes),
    },
  ],
};
